var path = '/templates/projects.segments/show.html';
var html = "<zc-campaign-segment-show segment-id=segment.id project=project></zc-campaign-segment-show>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.segments/show.html
// module id = 1452
// module chunks = 0